import { render, staticRenderFns } from "./CurrenciesSelector.vue?vue&type=template&id=5d9d25c2"
import script from "./CurrenciesSelector.vue?vue&type=script&lang=js"
export * from "./CurrenciesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports